import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import * as feature from 'pages';
import { ProtectedRoute } from 'core/components';
import { appRoutes } from 'constants/app.constants';
import { SINGLE_NAVIGATION_PATHS } from '../../../../constants/single-navigation-paths';

interface RouteConfig {
    component: string;
    path: string;
    roles?: string[];
}
export const AppRoutes = (): React.JSX.Element => {
    // found better way to do this than I used to do
    // https://bobbyhadz.com/blog/javascript-convert-object-to-map
    const featureMap = new Map(Object.entries(feature));
    const getComponent = (item: RouteConfig): React.JSX.Element | null => {
        const SelectedComponent = featureMap.get(item.component) as
            | React.ComponentType
            | undefined;

        if (SelectedComponent) {
            return <SelectedComponent />;
        }

        return null;
    };

    return (
        <Routes>
            {appRoutes.map(
                (item: {
                    component: string;
                    path: string;
                    roles?: string[];
                }) => (
                    <Route
                        path={item.path}
                        element={
                            <ProtectedRoute requiredRoles={item?.roles}>
                                {getComponent(item)}
                            </ProtectedRoute>
                        }
                        key={item.component}
                    />
                )
            )}
            <Route
                path={'*'}
                element={
                    <Navigate
                        to={SINGLE_NAVIGATION_PATHS.NOT_FOUND_ERROR}
                        replace
                    />
                }
            />
        </Routes>
    );
};
